module.exports = __webpack_public_path__ + "static/media/email-feature-2.f32927bc.png";